"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Form_1 = __importDefault(require("react-bootstrap/Form"));
var Row_1 = __importDefault(require("react-bootstrap/Row"));
var prop_types_1 = __importDefault(require("prop-types"));
var FormRow_module_scss_1 = __importDefault(require("./FormRow.module.scss"));
var FormRow = function (props) {
    var _a = props.rowNameId, rowNameId = _a === void 0 ? '' : _a, required = props.required, requiredMark = props.requiredMark, layout = props.layout, bsPrefix = props.bsPrefix, children = props.children;
    var isHorizontal = function () {
        return layout === 'horizontal';
    };
    return (react_1.default.createElement(Row_1.default, { className: FormRow_module_scss_1.default.formRow, bsPrefix: bsPrefix },
        react_1.default.createElement(Form_1.default.Group, { className: "col-md-6" },
            react_1.default.createElement(Form_1.default.Label, null,
                rowNameId,
                required && react_1.default.createElement("span", { className: "text-danger" }, requiredMark)),
            children)));
};
FormRow.propTypes = {
    rowNameId: prop_types_1.default.string,
    required: prop_types_1.default.bool,
    requiredMark: prop_types_1.default.string,
    layout: prop_types_1.default.string,
    bsPrefix: prop_types_1.default.string,
};
FormRow.defaultProps = {
    requiredMark: "*"
};
exports.default = FormRow;
//# sourceMappingURL=FormRow.js.map